import { isNotNil } from '@flowio/is';

/**
 * Injects a `link` element into the `head` section of the document,
 * pointing to the url specified.
 * @param url The URL from which to load the script.
 * @param options Includes callbacks and cross origin properties.
 */
export default function loadStyleSheet(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$crossOrigin = options.crossOrigin,
      crossOrigin = _options$crossOrigin === void 0 ? null : _options$crossOrigin,
      onError = options.onError,
      onLoad = options.onLoad;
  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  link.media = 'all';
  link.crossOrigin = crossOrigin;

  if (onLoad) {
    link.onload = function handleLoad() {
      link.onerror = null;
      link.onload = null;
      onLoad();
    };
  }

  if (onError) {
    link.onerror = function handleError() {
      link.onerror = null;
      link.onload = null;
      onError();
    };
  }

  if (isNotNil(head)) head.appendChild(link);
  return link;
}
//# sourceMappingURL=loadStyleSheet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/loadStyleSheet.js
// module id = 489
// module chunks = 0 1